import clsx from 'clsx'
import React, { useEffect, useMemo, useState } from 'react'

function Dot({
  position,
}: {
  position: {
    left: number | string
    top: number | string
  }
}) {
  const [opacity, setOpacity] = useState(0)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setOpacity(1)
      const intervalId = setInterval(() => {
        setOpacity((opacity) => (opacity === 0 ? 1 : 0))
      }, 1200)

      return () => clearInterval(intervalId)
    }, Math.random() * 2000)

    return () => clearTimeout(timeoutId)
  }, [])

  return (
    <div
      className='loading-dot absolute transition-opacity duration-700 ease-linear'
      style={{ ...position, opacity }}
    >
      <div className='relative flex items-center justify-center'>
        <div className='border-1 relative inline-flex h-2.5 w-2.5 items-center justify-center rounded-full border border-black bg-white/95' />
      </div>
    </div>
  )
}

interface LoadingAnimationProps {
  width: number
  height: number
  hideBackground?: boolean
  dotDensity?: number
}

function LoadingAnimation({
  width,
  height,
  hideBackground,
  dotDensity = 0.000025,
}: LoadingAnimationProps) {
  const widthPixels = width
  const heightPixels = height
  const length = Math.round(widthPixels * heightPixels * dotDensity)

  const dots = useMemo(() => {
    return Array.from({
      length,
    }).map(() => ({
      left: Math.random() * 80 + '%',
      top: Math.random() * 80 + '%',
    }))
  }, [length])

  return (
    <div
      className={clsx('relative h-full w-full overflow-hidden', {
        'bg-transparent': hideBackground,
        'bg-black/20': !hideBackground,
      })}
    >
      {dots.map((dotPosition, index) => (
        <Dot key={index} position={dotPosition} />
      ))}
    </div>
  )
}

export default LoadingAnimation
